import { FC } from "react";
import "video.js/dist/video-js.css";
import Like from "../../../../../assets/icon/Like";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../hooks/redux-hooks";
import {
  selectMainState,
  setButtonState,
  setIdTrack,
  setAudioOverTop,
  setPlayRadio,
  setPlayTrack,
  setTrackLink,
  setVoteModal,
} from "../../../../../store/slices/main";
import LikePlayer from "../../../../../assets/icon/LikePlayer";
import { addRemoveLike } from "../../../../../api/asyncThuncks/audioTracks";
import Cover from "../../../../../assets/icon/Cover";
import { getHomePageSetting } from "../../../../../api/asyncThuncks/settings";
import { addRemoveContestsLike } from "../../../../../api/asyncThuncks/contestsCards";
import {
  setSettingPlaylistTrackNumber,
  setSettingStopPlayingPlaylist,
} from "../../../../../store/slices/playlists";
import VoteButton from "../../../../../assets/icon/VoteButton";
import ButtonPlayer from "../../../../../components/common/button/ButtonPlayer";
import PlayCounter from "../../../../../assets/icon/PlayCounter";
import { setConfirmationByMessage } from "../../../../../store/slices/contests";
import Favorite from "../../../../../assets/icon/Favorite";

type IProps = {
  index: number;
  id: string;
  icon?: string;
  trackName: string;
  artist: string;
  like?: number;
  isLiked?: boolean;
  voices?: string;
  length?: string;
  arrayLength: number;
  trackLink: string;
  buttonStates: string;
  idRow?: string;
  keyRow?: number;
  isHovered: boolean;
  contestId?: string;
  playCounter?: number;
  onToggleLike: (id: string) => void;
};

const PlaylistByContest: FC<IProps> = ({
  index,
  id,
  icon,
  trackName,
  artist,
  like,
  isLiked,
  voices,
  length,
  arrayLength,
  trackLink,
  buttonStates,
  idRow,
  keyRow,
  isHovered,
  contestId,
  playCounter,
  onToggleLike,
}) => {
  const dispatch = useAppDispatch();
  const {
    radioPlayer: { player, radio },
    idPlayingTrack,
  } = useAppSelector(selectMainState);

  const voteHandleClick = async () => {
    onToggleLike(id);

    if (contestId) {
      await dispatch(addRemoveContestsLike({ contestId, audioTrackId: id }));
    } else {
      await dispatch(addRemoveLike({ id }));
    }
  };

  const handleClick = () => {
    dispatch(setPlayTrack(true));
    dispatch(setPlayRadio(false));
    dispatch(setTrackLink(trackLink));

    if (player && radio) {
      player.stop();
      dispatch(setButtonState("play"));
    }
    dispatch(
      setIdTrack({
        idTrack: id,
        cover: { icon },
        name: trackName,
        artist,
        isLiked,
        trackLink,
      })
    );

    dispatch(setAudioOverTop(true));
    stopNextPlaying();
  };

  const stopNextPlaying = () => {
    dispatch(setSettingPlaylistTrackNumber(0));
    dispatch(setSettingStopPlayingPlaylist(true));
  };

  return (
    <div
      className={`flex justify-between items-center max-h-16 md:max-h-10 w-full transition-all duration-80 px-3 py-6`}
      //  ${
      //   isHovered &&
      //   keyRow === index &&
      //   "md:hover:bg-black hover:bg-opacity-[4%] md:hover:bg-opacity-20 rounded-sm"
      // }
    >
      <div onClick={handleClick} className="flex items-center w-full cursor-pointer">
        <div className="flex items-center justify-center w-[3.75rem] h-[3.75rem] md:w-[2.5rem] md:h-[2.5rem] rounded-md overflow-hidden relative shrink-0">
          {icon ? (
            <img className="object-cover w-full h-full" src={icon} alt="icon" />
          ) : (
            <Cover />
          )}
          <div className={`w-[30px] h-[30px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 md:top-1 md:left-1 md:transform-none ${isHovered && keyRow === index ? 'block' : 'block md:hidden'}`}>
            <ButtonPlayer
              width="30"
              height="30"
              type={idPlayingTrack.idTrack === id ? "" : "play"}
              radio={false}
              playForTrack={true}
              onClick={handleClick}
            />
          </div>
        </div>
        <div className="pl-4 md:w-full md:flex md:items-center md:justify-between">
          <h4
            className={`min-w-[11rem] max-w-[11rem] text-base font-semibold text-ellipsis overflow-hidden whitespace-nowrap md:min-w-[15rem] md:max-w-[15rem] ${
              idPlayingTrack.idTrack === id ? "text-orange" : "text-black"
            }`}
          >
            {trackName}
          </h4>
          <p className="min-w-[11rem] max-w-[11rem] text-[13px] text-ellipsis overflow-hidden whitespace-nowrap md:min-w-[25rem] md:max-w-[25rem] md:text-center">
            {artist}
          </p>
          <div className="flex items-center text-[13px]">
            <div className="">
              <span>{length}</span>
              <span>・</span>
            </div>
            <>
              <PlayCounter />
              <div>
                <span className="pl-1">{playCounter}</span>
                <span>・</span>
              </div>
            </>
            <Favorite />
            <span className="pl-1">{voices}</span>
          </div>
        </div>
      </div>

      <button
        onClick={() => {
          dispatch(
            setConfirmationByMessage({
              phone: "",
              contestId: contestId ?? "",
              audioTrackId: id,
            })
          );
          dispatch(setVoteModal(true));
        }}
        className="md:pl-5 hover:transition-ease-in-out hover:-translate-y-[1px] hover:bg-opacity"
      >
        <VoteButton />
      </button>
    </div>
  );
};

export default PlaylistByContest;
